import { motion } from "framer-motion";

const upcomingProjects = [
  {
    title: "Corporate Office Interior",
    location: "Gurgaon",
    image: "/projects/upcoming/office1.jpg",
  },
  {
    title: "Luxury Restaurant Design",
    location: "Delhi",
    image: "/projects/upcoming/restaurant.jpg",
  },
];

export default function ProjectsUpcoming() {
  return (
    <section className="py-24 bg-white min-h-screen">

      <div className="max-w-7xl mx-auto px-6 md:px-16">

        <h1 className="text-4xl font-serif mb-12 text-center">
          Upcoming Projects
        </h1>

        <div className="grid md:grid-cols-3 gap-6">

          {upcomingProjects.map((project, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="overflow-hidden"
            >

              <img
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover"
              />

              <div className="mt-4">

                <h3 className="font-serif text-xl">
                  {project.title}
                </h3>

                <p className="text-gray-500">
                  {project.location}
                </p>

                <span className="text-sm text-[#C9A962]">
                  Starting Soon
                </span>

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
}